import './styles.css'
import { useState, useEffect } from "react";

import { redirectToAuthCodeFlow, getAccessToken} from '../spotifyAPI';

const clientId = "a7ec7b2d86c448a480bf3b1066b5e2f3";
const params = new URLSearchParams(window.location.search);
const code = params.get("code");

async function login(setLoggedIn){
    if(!code){
        localStorage.removeItem("accessToken");

        redirectToAuthCodeFlow(clientId);
    }
    else {
        // If code is available, fetch the access token
        try {
            const accessToken = await getAccessToken(clientId, code);

            // Store the access token in localStorage
            localStorage.setItem("accessToken", accessToken);

            // Set the loggedIn state to true
            setLoggedIn(true);
        } 
        catch (error) {
            console.error("Error fetching access token:", error);
        }
    }
}

function Login({ setLoggedIn }) {
    useEffect(() => {
        if (code && !localStorage.getItem("accessToken")) {
          // If the code is already in the URL, fetch the access token
            login(setLoggedIn);
        }
    }, [code, setLoggedIn]);

    return (
        <div id="login">
            <h1 id="welcome">Welcome to QShare</h1>
            <p style={{font_size: 18 + 'px', margin_top: 25 + 'px'}}>Seemlessly recommend and add songs to your friends' queues, to share music without a jam.</p>
            <h3 style={{margin_top: 25 + 'px'}}>Login now and connect with your friends</h3>
            <button id="loginButton" onClick={() => login(setLoggedIn)}>
                <b>Login with Spotify</b>
            </button>
        </div>
    )
}

export default Login;